import Coordie from "./coordies/coordies.jsx";
import Src from "./src/src.jsx";
import Finance from "./finance/finance.jsx";
import Spons from "./spons/spons.jsx";
import Tech from "./techops/techops.jsx";
import Design from "./Design/design.jsx";
import Media from "./Media/Media.jsx";
import "./jvm.css";

function JVM () {
  return (
    <>
      <div className="chlna">
        <h1> JAGRITI VIDYA MANDIR</h1>
      </div>
      <br />
      <hr />
      <br />
      <Coordie />
      <br />
      <br />
      <Src />
      <br />
      <br />
      <Tech /> 
      <br />
      <br />
      <Spons />
      <br />
      <br />
      <Finance />
      <br />
      <br />
      <Design />
      <br />
      <br />
      <Media /> <br />
    </>
  );
}

export default JVM;

// const Data = [
//         {
//           name: "Tvisha Khakhar",
//           facebookLink: "https://www.facebook.com/profile.php?id=100087648426543&mibextid=ZbWKwL",
//           linkedinLink: "https://www.linkedin.com/in/tvisha-khakhar-a71547250",
//           email: "tvisha@gyws.org",
//           imageUrl: "https://drive.google.com/open?id=1CdRXhNOMEFVTzGAbnmXN06HPPCFxoYU5",
//           position: ""
//         },
//         {
//           name: "Lokesh Saran",
//           facebookLink: "https://www.facebook.com/profile.php?id=100087515113955&mibextid=ZbWKwL",
//           linkedinLink: "https://www.linkedin.com/in/lokesh-saran-b0535925",
//           email: "lokesh.saran@gyws.org",
//           imageUrl: "https://drive.google.com/open?id=14pPGd9FVHuGFIGT6oFHiTlfWn0EJx0va",
//           position: ""
//         },
//         {
//           name: "Nazmi Syed",
//           facebookLink: "https://www.facebook.com/profile.php?id=100087177596392&mibextid=ZbWKwL",
//           linkedinLink: "www.linkedin.com/in/nazmi-syed-63980b269",
//           email: "nazmi.syed@gyws.org",
//           imageUrl: "https://drive.google.com/open?id=185WHjNeRQM9ej8AH4bQ2EY2eCvViHFsx",
//           position: ""
//         },
//         {
//           name: "Anmol Singh",
//           facebookLink: "https://m.facebook.com/profile.php?id=100007010851430",
//           linkedinLink: "https://www.linkedin.com/in/anmol-singh-55025b259?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
//           email: "anmol.singh@gyws.org",
//           imageUrl: "https://drive.google.com/open?id=1ogaDHY2pE3PGVGF1w8aeHrLjpx6HYFt5",
//           position: ""
//         },
//         {
//           name: "Siddhesh Agrawal",
//           facebookLink: "https://www.facebook.com/profile.php?id=100086241404924",
//           linkedinLink: "https://www.linkedin.com/in/siddhesh-agrawal-3ba110252/",
//           email: "siddhesh.agrawal@gyws.org",
//           imageUrl: "https://drive.google.com/open?id=1vR35GQZScuNKCqV-2G0sAew3uocpDNxE",
//           position: ""
//         },
//         {
//           name: "Hrishikesh Tiwari",
//           facebookLink: "https://www.facebook.com/profile.php?id=61555836611584",
//           linkedinLink: "https://www.linkedin.com/in/hrishikesh-tiwari-338524252?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
//           email: "hrishikesh.tiwari@gyws.org",
//           imageUrl: "https://drive.google.com/open?id=1Onvcru32Y43b8oiUilTycU_7s1BvzIwp",
//           position: ""
//         },
//         {
//           name: "Syed Mehran Ahmed",
//           facebookLink: "https://www.facebook.com/profile.php?id=100087564341044",
//           linkedinLink: "https://www.linkedin.com/in/syedmehran26",
//           email: "syed.ahmed@gyws.org",
//           imageUrl: "https://drive.google.com/open?id=19fDMHFV7jQbYuOnN6WNGBHGCQR67QFLX",
//           position: ""
//         },
//         {
//           name: "Suchismita Sahoo",
//           facebookLink: "https://www.facebook.com/profile.php?id=61550090230775",
//           linkedinLink: "https://www.linkedin.com/in/suchismita-s-5282072ab?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
//           email: "suchismita.sahoo@gyws.org",
//           imageUrl: "https://drive.google.com/open?id=1Izab4f223Kpvt-FR0HzSO_0fjLcbnphv",
//           position: ""
//         },

//         {
//           name: "Swaralipi Datta",
//           facebookLink: "https://www.facebook.com/profile.php?id=100087185364901",
//           linkedinLink: "https://www.linkedin.com/in/swaralipi-datta04/",
//           email: "swaralipi.datta@gyws.org",
//           imageUrl: "https://drive.google.com/open?id=193vSuTx2EUTOQlYyX4zH0BFJI06oOcuG",
//           position: ""
//         },
//     ]
